import checkVersion from './check-version';
import { BRIDGE_NAME, BRIDGE_STATUS } from './bridge-const';

const REPORT_PV = (type = 'collector') => `/app/web/v2/rp?type=${type}`;
const DEBUG = () => location && location.hostname.indexOf('app.') !== 0;

const callBridge = (name, params, callback = null) => {
    if (DEBUG() && name !== BRIDGE_NAME.GET_LOGIN_INFO) {
        try {
            const reportData = new FormData();
            reportData.append('name', name);
            reportData.append('params', JSON.stringify(params));
            navigator.sendBeacon &&
                navigator.sendBeacon(REPORT_PV('log'), reportData);
        } catch (e) {
            console.error(e);
        }
    }
    getJsBridge().call(name, params, responseText => {
        if (DEBUG() && name !== BRIDGE_NAME.GET_LOGIN_INFO) {
            try {
                const reportData = new FormData();
                reportData.append('name', name);
                reportData.append('params', JSON.stringify(params));
                reportData.append('responseText', responseText);
                navigator.sendBeacon &&
                    navigator.sendBeacon(REPORT_PV('log'), reportData);
            } catch (e) {
                console.error(e);
            }
        }
        if (!callback) {
            return;
        }

        try {
            callback(JSON.parse(responseText));
        } catch (error) {
            DEBUG() && console.error(error);
            callback({});
        }
    });
};

const checkJsBridge = () => {
    let counter = 0;
    const check = resolve => {
        if (typeof getJsBridge !== 'undefined') {
            resolve(true);
        } else if (counter > 10) {
            resolve(false);
        } else {
            counter++;
            setTimeout(() => check(resolve), 10);
        }
    };
    return new Promise(resolve => {
        check(resolve);
    });
};

export const jsBridge = async (name, params = {}, callback = null) => {
    let hasBridge = typeof getJsBridge !== 'undefined';
    // 防止native注入jsBridge过慢
    if (!hasBridge) {
        hasBridge = await checkJsBridge();
    }

    // no js bridge or not support js bridge for current url
    if (!hasBridge) {
        DEBUG() && name === 'showToast' && console.log(params.content);
        return Promise.resolve(BRIDGE_STATUS.NO_BRIDGE);
    }

    // specially handle for SHOW_TOAST bridge for debug
    if (name === 'showToast' && typeof params.content !== 'string') {
        if (DEBUG()) {
            params.content = JSON.stringify(params.content);
        } else {
            return Promise.resolve(BRIDGE_STATUS.WRONG_PARAMS);
        }
    }

    // check version except GET_LOGIN_INFO bridge
    if (name !== BRIDGE_NAME.GET_LOGIN_INFO) {
        // check version support
        // use promise to resolve jsBridge status,
        // the reason is callback for jsbridge is async
        return new Promise(resolve => {
            callBridge(BRIDGE_NAME.GET_LOGIN_INFO, {}, loginInfo => {
                const curVer = loginInfo['app_ver'] || '9.9';
                let env = '';
                if ((loginInfo.app_id || '').indexOf('10001') === 0) {
                    env = 'android';
                } else if ((loginInfo.app_id || '').indexOf('10002') === 0) {
                    env = 'ios';
                }
                if (checkVersion(name, curVer, env)) {
                    callBridge(name, params, callback);
                    resolve(BRIDGE_STATUS.DONE);
                } else {
                    resolve(BRIDGE_STATUS.WRONG_VERSION);
                }
            });
        });
    }

    // has bridge and bridge name is GET_LOGIN_INFO
    callBridge(name, params, callback);
    return Promise.resolve(BRIDGE_STATUS.DONE);
};



// WEBPACK FOOTER //
// ./src/util/jsbridge/bridge.js